import { TObject } from 'utils/types';

import { MESSAGE_STATUSES } from './constants';
import {
  ICustomMessages,
  INotificationCenterData,
  IUserGroupData,
  NOTIFICATION_STATE,
  TCustomMessagesData,
} from './types';

export const normalizeNotificationCenterData = (
  data?: TObject,
): INotificationCenterData => {
  return {
    creationDate: (data?.creationDate as string) || '',
    id: (data?.id as number) || 0,
    message: (data?.message as string) || '',
    state: (data?.state as NOTIFICATION_STATE) || null,
    type: (data?.type as string) || '',
    userId: (data?.userId as string) || '',
  };
};

export const normalizeUserGroupData = (data?: TObject): IUserGroupData => {
  return {
    created: (data?.created as string) || '',
    id: (data?.id as number) || 0,
    name: (data?.name as string) || '',
    users: (data?.users as string[]) || [],
  };
};

export const normalizeCustomMessagesData = (
  data?: TCustomMessagesData,
): ICustomMessages => {
  return {
    body: (data?.body as string) || null,
    created: (data?.created as string) || '',
    deliveryTime: (data?.deliveryTime as string) || '',
    id: (data?.id as number) || 0,
    name: (data?.name as string) || '',
    status: (data?.status as MESSAGE_STATUSES) || '',
    userGroup: normalizeUserGroupData(data?.userGroup),
    userId: (data?.userId as string) || '',
    userLogin: (data?.userLogin as string) || '',
  };
};
